import React from "react";
import PropTypes from "prop-types";
import CustomerAction from "./CustomerAction";

const CustomerActionRow = ({
  customerAction,
  labelBasic,
  labelSpecial,
  labelClaim,
  labelWarehouse,
  labelCommission,
  openOrders,
  invertClass,
  activeOrderType,
  openDualCart,
  isSpecialCart
}) => (
  <div className="faHolder">
    <div className={`actionBar ${invertClass}`}>
      <CustomerAction
        title={labelBasic}
        icon="fa fa-list"
        isOrderOpened={openOrders && openOrders["basic"]}
        action={() => customerAction("basic")}
        active={activeOrderType === "basic" && "active"}
      />

      <CustomerAction
        title={labelSpecial}
        icon="fa fa-edit"
        isOrderOpened={openOrders && openOrders["special"]}
        action={() => customerAction("special")}
        active={activeOrderType === "special" && "active"}
      />

      <CustomerAction
        title={labelClaim}
        icon="fa fa-history"
        isOrderOpened={openOrders && openOrders["claim"]}
        action={() => customerAction("claim")}
        active={activeOrderType === "claim" && "active"}
      />

      <CustomerAction
        title={labelWarehouse}
        icon="fa fa-university"
        isOrderOpened={openOrders && openOrders["warehouse"]}
        action={() => customerAction("warehouse")}
        active={activeOrderType === "warehouse" && "active"}
      />

      <CustomerAction
        title={labelCommission}
        icon="fa fa-server"
        isOrderOpened={openOrders && openOrders["commision"]}
        action={() => customerAction("commision")}
        active={activeOrderType === "commision" && "active"}
      />

      <CustomerAction
        title={'Dual Cart'}
        icon="fa fa-shopping-cart"
        action={() => {
          openDualCart();
          console.log('open dual cart')
        }
        }
        active={'right-position'}

        isSpecialCart={isSpecialCart}
      />
    </div>
  </div>
);

CustomerActionRow.propTypes = {
  customerAction: PropTypes.string,
  labelBasic: PropTypes.string,
  labelSpecial: PropTypes.string,
  labelClaim: PropTypes.string,
  labelWarehouse: PropTypes.string,
  labelCommission: PropTypes.string,
  openOrders: PropTypes.array,
  invertClass: PropTypes.string,
  activeOrderType: PropTypes.string,
  openDualCart: PropTypes.string,
  isSpecialCart: PropTypes.bool
};

export default CustomerActionRow;



// WEBPACK FOOTER //
// ./src/routes/CustomerList/components/CustomerActionRow.js